import { Button } from "@material-ui/core";
import React from "react";
import { CustomTable, SearchTableInput } from "../../../components";
import PodModal from "./PodModal";
import { useNavigate } from "react-router-dom";
import { ppodTableHeading } from "../../../assets/lib/ppod";
import { Box, Typography } from "@mui/material";

const customStyle = {
  root: {
    padding: "10px 40px",
    width: "100%",
    display: "flex",
    flexDirection: "column",
    gap: "30px",
  },
  buttonContainer: {
    height: "50px",
    display: "flex",
    justifyContent: "space-between",
  },
  actionBtn: {
    display: "flex",
    gap: "30px",
  },
  '@media (max-width: 390px)': {
    root: {
      padding: "5px 5px", 
      gap: "60px", 
      width:"80vw",
    },
    buttonContainer: {
      height: "25px",
      justifyContent: "left",
      flexWrap: "wrap",
    },
    actionBtn: {
      marginTop:"5px",
      marginLeft:"-2px",
      gap: "5px",
      flexDirection: "row", 
      height: "15px",
      width:"75vw"
    },
  },
};

const Layout = (props) => {
  const {
    podTableData,
    fetchPodNumber,
    isTableLoading,
    currentPage,
    totalLength,
    handlePageChange,
    handlePageSize,
    handleSearchQuery,
    handleTableSorting,
    isModalOpen,
    setIsModalOpen,
    handleSubmitModal,
    podState,
    getPodInput,
    errorFields,
    loadingModal,
    pusersData,
    pusersMenu,
    setPusersMenu,
  } = props;

  return (
    <Box sx={customStyle.root}>
      <Box sx={customStyle.buttonContainer} style={{ marginTop:"30px",}}>
        <SearchTableInput
          tableHeading={ppodTableHeading}
          handleSearchQuery={handleSearchQuery}
        />
        <Box >
          <Button
            variant="contained"
            style={{
              textTransform: "none",
              fontFamily:"Roboto",
              backgroundColor: "#8b003c",
              
              color: "white",
              padding: "12px 24px",
              borderRadius: "12px",
              '&:hover': {
                backgroundColor: "#8b003c",
                color: "white",
              },
              '@media (max-width: 480px)': {
                width: "100%",
              },
            }}
            onClick={() => {
              setIsModalOpen(true);
              fetchPodNumber();
            }}
          >
            <Typography variant="button">
              Add PPod
            </Typography>
          </Button>
        </Box>
      </Box>

      <Box>
        <CustomTable
          columns={ppodTableHeading}
          data={podTableData}
          isLoading={isTableLoading}
          currentPage={currentPage}
          totalLength={totalLength}
          handlePageChange={handlePageChange}
          handlePageSize={handlePageSize}
          handleTableSorting={handleTableSorting}
        />
      </Box>

      <PodModal
        setIsModalOpen={setIsModalOpen}
        isModalOpen={isModalOpen}
        handleSubmitModal={handleSubmitModal}
        podState={podState}
        getPodInput={getPodInput}
        errorFields={errorFields}
        loadingModal={loadingModal}
        pusersData={pusersData}
        pusersMenu={pusersMenu}
        setPusersMenu={setPusersMenu}
      />
    </Box>
  );
};

export default Layout;
